"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _noop2 = _interopRequireDefault(require("lodash/noop"));

require("./Radio.css");

var _excluded = ["type", "name", "id", "label", "onChange", "disabled", "size", "typeCheck", "bgCheck", "inputContainerClassName", "checked"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function RadioInput(_ref) {
  var type = _ref.type,
      name = _ref.name,
      id = _ref.id,
      label = _ref.label,
      onChange = _ref.onChange,
      disabled = _ref.disabled,
      size = _ref.size,
      typeCheck = _ref.typeCheck,
      bgCheck = _ref.bgCheck,
      inputContainerClassName = _ref.inputContainerClassName,
      checked = _ref.checked,
      rest = _objectWithoutProperties(_ref, _excluded);

  var handleChange = (0, _react.useCallback)(function (e) {
    onChange(e.target.checked);
  }, [onChange]);
  var handleClick = (0, _react.useCallback)(function () {
    onChange(!checked);
  }, [onChange, checked]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "Radio flex items-center ".concat(inputContainerClassName),
    onClick: disabled ? undefined : handleClick,
    onKeyDown: disabled ? undefined : handleClick
  }, /*#__PURE__*/_react.default.createElement("input", _extends({
    disabled: disabled,
    type: type,
    id: id,
    name: name,
    className: "Radio__control-input",
    onChange: handleChange
  }, rest)), /*#__PURE__*/_react.default.createElement("label", {
    className: "Radio__control-label ml-1 ".concat(typeCheck && bgCheck),
    htmlFor: id
  }, label));
}

RadioInput.propTypes = {
  type: _propTypes.default.string,
  size: _propTypes.default.string,
  name: _propTypes.default.string,
  id: _propTypes.default.any,
  label: _propTypes.default.string,
  onChange: _propTypes.default.func,
  disabled: _propTypes.default.bool,
  typeCheck: _propTypes.default.bool,
  bgCheck: _propTypes.default.bool,
  inputContainerClassName: _propTypes.default.string,
  checked: _propTypes.default.bool
};
RadioInput.defaultProps = {
  type: 'radio',
  size: 'md',
  name: '',
  id: null,
  label: '',
  onChange: _noop2.default,
  disabled: false,
  typeCheck: false,
  bgCheck: false,
  inputContainerClassName: '',
  checked: false
};
var _default = RadioInput;
exports.default = _default;